function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3348",
  "data-name": "Grupo 3348",
  transform: "translate(-990 -889)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Check",
  transform: "translate(990.288 889.288)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_1",
  "data-name": "Elipse 1",
  cx: 23,
  cy: 23,
  r: 23,
  transform: "translate(-0.288 -0.288)",
  fill: "#ecb42d"
})), /*#__PURE__*/React.createElement("path", {
  id: "_Color",
  "data-name": " \\u21B3Color",
  d: "M10.117,17.967,2.529,10.848,0,13.221l10.117,9.492L31.8,2.373,29.268,0Z",
  transform: "translate(996.813 900.357)",
  fill: "#fff"
}));

var SvgGoldCheck = function SvgGoldCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoldCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/GoldCheck.c7993655.svg";
export { ForwardRef as ReactComponent };